<script lang="ts">
  import { tooltip } from "@kontextwerk/web-sdk/core/overlay/tooltip"
  import TableFormCell from "@kontextwerk/web-sdk/ui/layout/TableFormCell.svelte"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import PropertyAsyncSelect from "../../../../../../../../../../../../../../_shared/_modules/property-async-select"
  import type { LoadListTableRow } from "../../../../_shared/_logic/load-list-row-model"

  type Props = {
    row: LoadListTableRow
    selectedProperty: Property | null
    organizationId: string
    seedProperties: Property[]
    disabled?: boolean
    onChange: (row: LoadListTableRow, property: Property | null) => void
  }

  const {
    row,
    selectedProperty,
    organizationId,
    seedProperties,
    disabled = false,
    onChange,
  }: Props = $props()
  const isMissing = $derived(row.status === "pending" || !row.propertyId)
  const backlogResolution = $derived(isMissing ? (row.backlogResolution ?? null) : null)
</script>

<div class="batch-property-select-cell" use:tooltip={{ content: row.address }}>
  {#if isMissing}
    <div class="batch-missing-address">
      <span class="batch-missing-address__text">{row.address}</span>
      {#if !backlogResolution}
        <StatusTag size="sm" label="Fehlt" color="amber" />
      {/if}
    </div>
  {/if}
  <TableFormCell style="min-width: 0;">
    <PropertyAsyncSelect
      clearable={false}
      id={`batch-property-select-${row.id}`}
      {organizationId}
      {seedProperties}
      value={row.propertyId ?? ""}
      {selectedProperty}
      presentation="two-line"
      placeholder={backlogResolution ? "Liegenschaft zuordnen" : "Liegenschaft"}
      labelVisibility="hidden"
      brightBackground={false}
      {disabled}
      onChange={(property) => onChange(row, property)}
    />
  </TableFormCell>
</div>

<style lang="less" global>
  .batch-property-select-cell {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .batch-missing-address {
    display: flex;
    align-items: flex-start;
    gap: 0.35rem;
    margin-bottom: 0.4rem;
    min-width: 0;
  }

  .batch-missing-address__text {
    min-width: 0;
    color: var(--text-100);
    font-size: 0.76rem;
    font-weight: 800;
    line-height: 1.15;
    overflow-wrap: anywhere;
  }

  .batch-property-select-cell :global(.fieldShell) {
    margin: 0;
    min-width: 0;
  }

  .batch-property-select-cell :global(.svelte-select),
  .batch-property-select-cell :global(.select-input-shell) {
    min-width: 0;
  }

</style>
